"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

exports.default = function (params) {
    params = params || {};
    var newLocale = params.newLocale;
    var oldLocale = params.oldLocale;

    var self = {};

    self.modify = function (obj, shouldDelete) {
        if (newLocale === oldLocale) return;
        changeLocaleStringsUnderObj(obj, shouldDelete, oldLocale, newLocale);
    };

    return self;
};

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Recursive function that runs on an object, ensuring all localized strings have values under "newLocale".
 */
function changeLocaleStringsUnderObj(obj, shouldDelete, defaultLocale, newLocale) {
    if (!obj) return obj;

    switch (typeof obj === "undefined" ? "undefined" : (0, _typeof3.default)(obj)) {

        // If element is string, try parsing it (JSON), change the inside object, and stringify it.
        case "string":
            {
                try {
                    var _obj = JSON.parse(obj);
                    _obj = changeLocaleStringsUnderObj(_obj, shouldDelete, defaultLocale, newLocale);
                    return (0, _stringify2.default)(_obj);
                } catch (e) {
                    // If there was an exception, this isn't JSON, don't do anything
                    return obj;
                }
            }

        // If element is object, go over all keys and values. If any of the keys are "en_US" (or the default locale),
        // ensure there is data in the new locale
        case "object":
            {
                _lodash2.default.each(obj, function (v, k) {
                    if (k === defaultLocale && typeof v === "string") {
                        obj[newLocale] = obj[newLocale] || v;
                        if (shouldDelete) delete obj[defaultLocale];
                    } else {
                        obj[k] = changeLocaleStringsUnderObj(v, shouldDelete, defaultLocale, newLocale);
                    }
                });
                return obj;
            }

        default:
            {
                return obj;
            }
    }
}

;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/ChangeLocaleModifier.js
// module id = 1088
// module chunks = 0